<div class="floating-container">
    <div class="logo-image-holder">
        <img src="/assets/img/homelogo.png" class="logo-image">
    </div>
    <div *ngIf="history.length > 0">
        <p class="floating-text">{{title}}</p>
        <div class="vertical-scroll border adptable-width-list">
            <div *ngFor="let entry of history">
                <div class="flex-container-center">
                    <div class="thumbnail-holder small-margin-vertical small-padding-vertical">
                        <img src="{{entry.Picture}}" class="thumbnail" onerror="this.src='assets/img/placeholder.png'">
                    </div>
                    <div class="small-margin small-padding fill-parent-width">
                        <div class="label block">{{entry.Name}}</div>
                        <div style="height: 5px;"></div>
                        <button mat-flat-button color="primary" class="fill-parent-width" (click)="goToStore(entry)">{{button}}</button>
                    </div>
                </div>
                <mat-divider></mat-divider>
            </div>
        </div>
    </div>
    <div style="height: 10px;"></div>
    <button mat-flat-button color="primary" class="fill-parent-width" (click)="contactUs()">{{contactus}}</button>
</div>